export default __webpack_public_path__ + "static/media/grafico.a93e803a.png";